import { createContext } from 'react';

export interface NotificationContextType {
  success: (message: React.ReactNode, description?: React.ReactNode, duration?: number) => string;
  error: (message: React.ReactNode, description?: React.ReactNode, duration?: number) => string;
  warning: (message: React.ReactNode, description?: React.ReactNode, duration?: number) => string;
  info: (message: React.ReactNode, description?: React.ReactNode, duration?: number) => string;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

